import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { DatosBusqueda } from '../model/DatosBusqueda';

@Injectable()
export class BuscarService {
  constructor(private http: Http) { }
   /**
   * Load DataBuscars from the static DataBuscars.json data, usually an API URL.
   *
   * @return {Observable<DatosBusqueda[]>} A list of DataBuscars.
   */
  getBuscar(): Observable<DatosBusqueda[]> {
    return this.http.get('assets/json/metadatos-busqueda.json')
      .map(res => res.json().data)
    // .catch(res => console.log(res));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/buscar.service.ts